import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { useAtomValue } from 'jotai';

import { cn, getAssetSrc, getDateDifference, getMonthDifference } from '@restworld/utils-common';
import { Card } from '@restworld/ui-components';
import { Heading } from '@restworld/ui-ds-base';

import { companyProfileAtom } from '../../job-position/job-position.atoms';

const monthLimit = 6;
export const CompanyInvolvementCard = () => {
  const { t } = useTranslation();
  const data = useAtomValue(companyProfileAtom);
  const { insertedAt } = data;

  const involvementTitle = useMemo(
    () => insertedAt && `${t('common:collaborate_with_us')} ${getDateDifference(insertedAt)}`,
    [insertedAt, t]
  );

  const isInvolvementMonthsOld = useMemo(() => insertedAt && getMonthDifference(insertedAt) > monthLimit, [insertedAt]);

  return (
    <CardWrapper>
      {isInvolvementMonthsOld ? (
        <Card>
          <Wrapper>
            <Heading color="white">{involvementTitle || '-'}</Heading>
            <Image src={getAssetSrc('/utils-assets/party-confetti.svg')} alt="" />
          </Wrapper>
        </Card>
      ) : null}
    </CardWrapper>
  );
};
export default CompanyInvolvementCard;
const CardWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('px-2 w-full', className)} {...props} />
);
const Image = ({ className, ...props }: React.ImgHTMLAttributes<HTMLImageElement>) => (
  <img className={cn('h-11 mt-4', className)} {...props} />
);
const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex items-center', className)} {...props} />
);
